import React, { useState, useEffect, useMemo } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit, Edit2, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { vehicleMaintenanceValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Popconfirm, Switch } from "antd";
import {
  useDeleteVehicleMaintenanceMutation,
  useInsertVehicleMaintenanceMutation,
  useUpdateVehicleMaintenanceMutation,
  useVehicleMaintenanceCategoriesQuery,
} from "AppQuries/master/VehicleMaintenance/vehiclemaintenance";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { numberToPointNumber } from "MainPages/Utils/decimal.utils";
import VehicleMaintenanceModal from "Components/Modal/master/VehicleMaintenanceModal";
import { render } from "preact/compat";

const VehicleMaintenance = () => {
  const userData = useSelector(loggedInUser);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isMount, setIsMount] = useState(false);
  const { watch, setValue } = useFormContext();
  // const {
  //   data,
  //   isLoading,
  //   isError,
  //   error,
  //   refetch: GetItems,
  // } = useVehicleMaintenanceCategoriesQuery(
  //   {
  //     companyCode: userData?.companyCode,
  //     isTrue: showActiveOnly,
  //   },
  //   {
  //     enabled: userData?.companyCode,
  //   }
  // );
  const methods = useForm({
    resolver: yupResolver(vehicleMaintenanceValidationSchema),
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { mutateAsync: insertVehicleMaintenance, isPending: isAdding } =
    useInsertVehicleMaintenanceMutation();
  const { mutateAsync: updateVehicleMaintenance, isPending: isUpdating } =
    useUpdateVehicleMaintenanceMutation();

  const { mutateAsync: deleteVehicleMaintenance, isPending: isDeleting } =
    useDeleteVehicleMaintenanceMutation();
  const [selectedItem, setSelectedItem] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    methods.reset();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // const ItemData = useMemo(() => {
  //   return Array.isArray(data)
  //     ? data.map((d, _id) => ({
  //         id: _id + 1,
  //         ...d,
  //       }))
  //     : [];
  // }, [data]);

  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      maintenanceID: 0,
      invoiceNumber: "",
      invoiceDate: "",
      dealerName: "",
      vehicleDescription: "",
      amountInclGST: numberToPointNumber(0),
      partServiced: "",
      maintenanceNextDueDate: "",
      lmNextDueDate: "",
      vehicleNumber: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    methods.reset({
      companyCode: userData?.companyCode,
      code: item.code,
      maintenanceID: item.maintenanceID,
      invoiceNumber: item.invoiceNumber,
      invoiceDate: item.invoiceDate,
      dealerName: item.dealerName,
      vehicleDescription: item.vehicleDescription,
      amountInclGST: numberToPointNumber(item.amountInclGST),
      partServiced: item.partServiced,
      maintenanceNextDueDate: item.maintenanceNextDueDate,
      lmNextDueDate: item.lmNextDueDate,
      vehicleNumber: item.vehicleNumber,
      isActive: item.isActive,
      createUser: item.createUser,
      createDate: item.createDate,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
    setShow(true);
  };

  const deleteItemHandler = (id) => {
    // const payload = {
    //   companyCode: userData?.companyCode,
    //   code: id,
    // };
    // deleteVehicleMaintenance(payload, {
    //   onSuccess: (data) => {
    //     if (data) {
    //       toast.success("Item Deleted Successfully.");
    //       setSelectedItem(null);
    //       setShow(false);
    //       GetItems();
    //     } else {
    //       toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //     }
    //   },
    //   onError: (error) => {
    //     toast.error(error.message || "Something went wrong.");
    //   },
    // });
  };

  const onSubmit = async (payload) => {
    console.log("payload", payload);
    if (selectedItem) {
      console.log(payload);
      const existingDataIndex = watch(
        "vehicleMaintenanceList"
      )?.findIndex((item) => item.maintenanceID === selectedItem.maintenanceID);
      const existingData = watch("vehicleMaintenanceList");

      existingData[existingDataIndex] = payload;

      setValue("vehicleMaintenanceList", [...existingData]);
    } else {
      const existingData = watch("vehicleMaintenanceList") || [];

      const newList =
        existingData.length > 0 ? [...existingData, payload] : [payload];

      setValue("vehicleMaintenanceList", newList);
    }

    // if (selectedItem) {
    //   // updateVehicleMaintenance(payload, {
    //   //   onSuccess: (data) => {
    //   //     if (data) {
    //   //       toast.success("Updated Successfully");
    //   //       setSelectedItem(null);
    setShow(false);
    //   //       GetItems();
    //   //     } else {
    //   //       toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //   //     }
    //   //   },
    //   //   onError: (error) => {
    //   //     toast.error(error.message || "Something went wrong.");
    //   //   },
    //   // });
    // } else {
    //   insertVehicleMaintenance(payload, {
    //     onSuccess: (data) => {
    //       if (data) {
    //         toast.success("Created Successfully.");
    //         setShow(false);
    //         GetItems();
    //       } else {
    //         toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
    //       }
    //     },
    //     onError: (error) => {
    //       toast.error(error.message || "Something went wrong.");
    //     },
    //   });
    // }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = useMemo(() => [
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (text) => format(new Date(text), "dd-MM-yyyy"),
    },
    { title: "Dealer Name", dataIndex: "dealerName", key: "dealerName" },
    {
      title: "Vehicle Description",
      dataIndex: "vehicleDescription",
      key: "vehicleDescription",
    },
    {
      title: "AmountInclGST",
      dataIndex: "amountInclGST",
      key: "amountInclGST",
    },
    {
      title: "Part Serviced",
      dataIndex: "partServiced",
      key: "partServiced",
    },
    {
      title: "Maintenance Next DueDate",
      dataIndex: "maintenanceNextDueDate",
      key: "maintenanceNextDueDate",
      render: (text) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "lmNextDueDate",
      dataIndex: "lmNextDueDate",
      key: "lmNextDueDate",
      render: (text) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      key: "vehicleNumber",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text, record) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>

          {/* <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger> */}
        </div>
      ),
    },
  ]);

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    watch("vehicleMaintenanceList"),
    searchColumns
  );

  // useEffect(() => {
  //   if (isMount) GetItems();

  //   setIsMount(true);
  // }, [showActiveOnly]);

  // if (isLoading || isAdding || isUpdating || isDeleting) {
  //   return <LoadingSpinner />;
  // }

  // if (isError) {
  //   return <Error404 error={error} />;
  // }

  return (
    <>
      <h4 className="header-title">Vehicle Maintenance</h4>

      <div className="card table-list-card border-0">
        <div className="card border-0">
          <div className="card-body pb-0">
            <div className="d-flex justify-content-between align-items-center">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />
              <button
                className="btn btn-primary"
                onClick={handleAddClick}
                type="button"
              >
                Add New
              </button>
            </div>
            <div className="table-responsive">
              <Table
                className="table  datanew"
                columns={columns}
                dataSource={filteredData}
              />
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <VehicleMaintenanceModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
        />
      </FormProvider>
    </>
  );
};

export default VehicleMaintenance;
